import React from 'react';
import { IconProps } from '.';

const SvgMedalCheckFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.286 2.143a3 3 0 0 0-4.57 0l-.042.05a1 1 0 0 1-.842.348l-.065-.005a3 3 0 0 0-3.231 3.231l.005.065a1 1 0 0 1-.349.842l-.05.042a3 3 0 0 0 0 4.57l.05.042a1 1 0 0 1 .349.841l-.005.065A3.002 3.002 0 0 0 8 15.43V22a1 1 0 0 0 1.555.832L12 21.202l2.445 1.63A1 1 0 0 0 16 22v-6.57a3.002 3.002 0 0 0 2.466-3.196l-.006-.065a1 1 0 0 1 .35-.841l.049-.042a3 3 0 0 0 0-4.57l-.05-.042a1 1 0 0 1-.349-.842l.006-.065a3 3 0 0 0-3.232-3.231l-.065.005a1 1 0 0 1-.841-.349l-.042-.05ZM10 20.132V16.15a3.002 3.002 0 0 0 4 0v3.98l-1.445-.963a1 1 0 0 0-1.11 0L10 20.132Zm4.708-11.425a1 1 0 0 0-1.415-1.414l-2.292 2.293-.293-.293a1 1 0 0 0-1.415 1.414l1 1a1 1 0 0 0 1.415 0l3-3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgMedalCheckFill;
